<template>
    <div class="special-service" v-if="isShow" @touchmove.prevent>
        <div class="service-info">
            <div class="mask" v-if="isSuccess">
                <div class="success-info">
                    <img class="success-bg" src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/common/success-bg.png">
                    <div class="tip-box">
                        <p class="info">老师，您好:<br>您的预约我们已经收到，请保持手机畅通，我们将在3天内安排专业顾问与您联系</p>
                        <button class="confirm-btn" @click="confirmInfo">确定</button>
                    </div>
                </div>
            </div>
            <img class="close-btn" src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/common/icon-close.png" @click="isShow=false">
            <p class="service-title">预约专业顾问回访</p>
            <p class="tip">请留下您的联系方式，我们会有专业顾问为您服务</p>
            <div class="tel-box">
                <input class="tel-input" maxlength="11" placeholder="联系电话:" v-model.trim="tel" @keyup="inputChange" @blur="validateTel"/>
                <p v-if="!isTelOk" class="err-mes">{{telErrMes}}</p>
            </div>
            <div class="radio-box">
                <span class="radio-des">当前学生规模：</span>
                <div class="radio-item">
                    <input class="radio-input" type="radio" id="school_zero" :value="1" v-model="school_scale">
                    <label class="radio-label" for="school_zero">暂无机构</label>
                </div>
                <div class="radio-item">
                    <input class="radio-input" type="radio" id="school_one" :value="2" v-model="school_scale">
                    <label class="radio-label" for="school_one">800人以下</label>
                </div><div class="radio-item">
                    <input class="radio-input" type="radio" id="school_two" :value="3" v-model="school_scale">
                    <label class="radio-label" for="school_two">800人以上</label>
                </div>
            </div>
            <textarea class="question-text" placeholder="问题描述：可以简单描述下您机构当前遇到的问题" v-model="question"></textarea>
            <button class="submit-btn" @click="goPre">完成并预约</button>
        </div>
    </div>
</template>
<script>
import authApi from '@/services/interface'
import { Message } from 'element-ui'
import { debounce } from '@/utils'
export default {
  data () {
    return {
      tel: '',
      telErrMes: '请输入手机号',
      question: '',
      school_scale: 1,
      isShow: false,
      isSuccess: false,
      isTelOk: true,
      timer: null
    }
  },
  mounted () {
    this.$EventBus.$on('open', () => {
      this.isShow = true
    })
    this.debounceSub = debounce(this.submitData, 500)
  },
  methods: {
    init () {
      this.tel = ''
      this.school_scale = 1
      this.isSuccess = false
      this.isTelOk = true
      this.question = ''
    },
    inputChange (e) {
      e.target.value = e.target.value.replace(/[^0-9]/g, '')
    },
    goPre () {
      if (this.validate()) {
        this.debounceSub()
      }
    },
    submitData () {
      let params = {
        tel: this.tel,
        student_scale: this.school_scale,
        description: this.question
      }
      authApi.newRegister(params).then(res => {
        if (res.ok) {
          this.isSuccess = true
        } else {
          Message({
            type: 'error',
            message: res.message
          })
        }
      })
    },
    validateTel () {
      if (!this.tel) {
        this.isTelOk = false
        this.telErrMes = '请输入手机号'
        return false
      } else if (this.tel.length !== 11) {
        this.isTelOk = false
        this.telErrMes = '请输入11位手机号'
        return false
      }
      this.isTelOk = true
      return true
    },
    validate () {
      return this.validateTel()
    },
    confirmInfo () {
      this.isShow = false
      this.init()
    },
    debounce (fn, delay = 1000) {
      var timeout = null // 创建一个标记用来存放定时器的返回值
      return function (e) {
        // 每当用户输入的时候把前一个 setTimeout clear 掉
        clearTimeout(timeout)
        // 然后又创建一个新的 setTimeout, 这样就能保证interval 间隔内如果时间持续触发，就不会执行 fn 函数
        this.timer = setTimeout(() => {
          console.log('ok')
          fn.apply(this, arguments)
        }, delay)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.special-service{
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0,0,0,0.4);
    z-index: 1500;
    .service-info{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: #ffffff;
        padding: 47px 28px 50px;
        border-radius:12px;
        text-align: left;
        .mask{
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0px;
            left: 0px;
            z-index: 8001;
            background: rgba(0,0,0,0.4);
            .success-info{
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width:560px;
                height:460px;
                background:#ffffff;
                border-radius:12px;
                .success-bg{
                    width: 560px;
                    height: 247px;
                }
                .tip-box{
                    padding: 27px 74px 37px 68px;
                    .info{
                        font-family: PingFangSC-Light;
                        font-size:17px;
                        font-weight:300;
                        color: #000000;
                        line-height: 25px;
                    }
                    .confirm-btn{
                        width: 400px;
                        display: block;
                        margin: 25px auto 0px;
                        height:50px;
                        border: none;
                        background:#FB594A;
                        box-shadow:0px 2px 4px 0px rgba(0, 0, 0, 0.08);
                        border-radius:4px;
                        font-size:22px;
                        font-family:PingFangSC-Regular;
                        color:#ffffff;
                        cursor: pointer;
                    }
                }
            }
        }
        .close-btn{
            position: absolute;
            width: 15px;
            height: 15px;
            top: 30px;
            right: 30px;
            cursor: pointer;
        }
        .service-title{
          font-size:24px;
          font-family:PingFangSC-Regular;
          font-weight:400;
          color:rgba(0,0,0,1);
          line-height:50px;
          text-align: center;
        }
        .tip{
            font-size:17px;
            font-family:PingFangSC-Light;
            font-weight:300;
            color:rgba(0,0,0,1);
            line-height:17px;
            margin-top:47px;
            padding-left:20px;
        }
        .tel-box{
            position: relative;
            .tel-input{
                width:600px;
                height:45px;
                background:rgba(0,0,0,0);
                border:1px solid #CECECE;
                border-radius:4px;
                outline: none;
                margin-top: 26px;
                padding-left: 20px;
                font-family: PingFangSC-Light;
                font-size: 17px;
                color: #000000;
                &:focus{
                    border: 1px solid #FB594A;
                }
                &::placeholder{
                    color: #ACACAC;
                    font-family: PingFangSC-Light;
                    font-size: 16px;
                }
            }
            .err-mes{
                position: absolute;
                top: 72px;
                left: 19px;
                color: #FB594A;
            }
        }
        .radio-box{
            padding-left: 20px;
            font-size:17px;
            font-family:PingFangSC-Light;
            color:#000000;
            line-height:16px;
            margin-top:32px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .radio-des{
                margin-right: 23px;
            }
            .radio-item{
                margin-right: 45px;
                .radio-input{
                    margin-right: 6px;
                    appearance: none;
                    position: relative;
                    outline: none;
                    &:before{
                        content: '';
                        width: 22px;
                        height: 22px;
                        border: 0px;
                        display: inline-block;
                        border-radius: 50%;
                        background: url('https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/common/icon-radio-default.png');
                        background-size: 100% 100%;
                        vertical-align: middle;
                    }
                    &:checked:before{
                        content: '';
                        width: 22px;
                        height: 22px;
                        border: 0px;
                        background: url('https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/common/icon-radio-select.png');
                        background-size: 100% 100%;
                        display: inline-block;
                        border-radius: 50%;
                        vertical-align: middle;
                    }
                }
                .radio-label{
                    margin: 0;
                }
                &:last-of-type{
                    margin-right: 0px;
                }
            }
        }
        .question-text{
            appearance: none;
            outline: none;
            margin-top: 32px;
            width: 600px;
            height: 155px;
            padding: 20px;
            border-radius: 4px;
            font-family: PingFangSC-Light;
            font-size: 16px;
            color: #000000;
            border: 1px solid #CECECE;
            resize:none;
            box-sizing: border-box;
            &:focus{
                border: 1px solid #FB594A;
            }
            &::placeholder{
                color: #ACACAC;
                font-family: PingFangSC-Light;
                font-size: 16px;
            }
        }
        .submit-btn{
            display: block;
            margin: 40px auto 0px;
            width:400px;
            height:50px;
            border: 0;
            outline: none;
            background:#FB594A;
            box-shadow:0px 2px 4px 0px rgba(0, 0, 0, 0.08);
            border-radius:4px;
            font-size:20px;
            font-family:PingFangSC-Regular;
            color: #ffffff;
            cursor: pointer;
        }
    }
}
</style>
